<router-outlet></router-outlet>
<ng-http-loader [backgroundColor]="'rgb(254, 74, 85)'" [debounceDelay]="100" [extraDuration]="300" [minDuration]="300"
  opacity=".6" [spinner]="spinkit.skCubeGrid">
</ng-http-loader>
